var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoToLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.33333 0.333344H2.99999C1.52733 0.333344 0.333328 1.52734 0.333328 3.00001V11C0.333328 12.4727 1.52733 13.6667 2.99999 13.6667H11C12.4727 13.6667 13.6667 12.4727 13.6667 11C13.6667 9.48601 13.6667 7.66668 13.6667 7.66668C13.6667 7.29868 13.368 7.00001 13 7.00001C12.632 7.00001 12.3333 7.29868 12.3333 7.66668V11C12.3333 11.736 11.736 12.3333 11 12.3333C8.77999 12.3333 5.21933 12.3333 2.99999 12.3333C2.26333 12.3333 1.66666 11.736 1.66666 11C1.66666 8.78001 1.66666 5.21934 1.66666 3.00001C1.66666 2.26334 2.26333 1.66668 2.99999 1.66668H6.33333C6.70133 1.66668 7 1.36801 7 1.00001C7 0.63201 6.70133 0.333344 6.33333 0.333344ZM11.3907 1.66668H9C8.632 1.66668 8.33333 1.36801 8.33333 1.00001C8.33333 0.63201 8.632 0.333344 9 0.333344H13C13.368 0.333344 13.6667 0.63201 13.6667 1.00001V5.00001C13.6667 5.36801 13.368 5.66668 13 5.66668C12.632 5.66668 12.3333 5.36801 12.3333 5.00001V2.60934L7.47133 7.47134C7.21133 7.73134 6.78866 7.73134 6.52866 7.47134C6.26799 7.21134 6.26799 6.78868 6.52866 6.52868L11.3907 1.66668Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoToLink);
export default __webpack_public_path__ + "static/media/goToLink.a4ea0f27fb6528ce8d8bc023cdccd0fd.svg";
export { ForwardRef as ReactComponent };